import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex w-full max-w-screen flex-col gap-3',
    item: 'border-text-inactive flex w-full items-baseline justify-between gap-6 border-b-[1px] py-4 md:py-5.5',
    label: 'text-text-inactive whitespace-nowrap',
    value: 'text-label-unimportant'
  },
  variants: {
    type: {
      base: {},
      dot: {
        item: 'after:border-bg-items-medium relative flex w-full items-end gap-5 border-b-0 p-0 text-xs after:absolute after:right-0 after:bottom-0 after:left-0 after:mx-2 after:mb-1 after:flex-grow after:border-b-2 after:border-dotted after:content-[""] md:p-0',
        label: 'text-text-main z-1 bg-white pr-5',
        value: 'text-text-main z-1 bg-white pl-5 font-medium'
      }
    }
  }
});
